
import { axios } from '@/utils/request'

export function getSmsCaptcha (mobile) {
  return axios({
    url: '/schoolManage/smsCode/' + mobile,
    method: 'get'
  })
}

export function queryByPhone (phone) {
  return axios({
    url: '/schoolManage/queryByPhone/' + phone,
    method: 'get'
  })
}

export function checkCode (obj) {
  return axios({
    url: '/schoolManage/checkCode',
    method: 'get',
    params: obj
  })
}

export function resetPwd (obj) {
  return axios({
    url: '/schoolManage/resetPwd',
    method: 'put',
    data: obj
  })
}
